<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-overlay
          :show="load"
          variant="transparent"
        >
          <template #overlay>
            <div class="text-center">
              <feather-icon
                icon="ClockIcon"
                size="40"
                animation="cyclon"
              />
              <p>Aguarde...</p>
            </div>
          </template>
          <b-card>
            <b-row>
              <b-col>
                <b-col
                  cols="12"
                >
                  <b-row align-h="between">
                    <b-col
                      md="1"
                      class="my-1"
                    >
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="[10, 15, 20]"
                      />
                    </b-col>
                    <b-col
                      md="2"
                      class="mb-1"
                    >
                      <label>Filtro por Status</label>
                      <v-select
                        v-model="statusFilter"
                        :options="optionsStatus"
                        multiple
                      />
                    </b-col>
                    <b-col
                      md="8"
                      class="my-1"
                    >
                      <b-form-input
                        v-model="filter"
                        placeholder="Pesquisar"
                        type="search"
                        size="sm"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
              <b-col md="12">
                <b-Table
                  hover
                  small
                  striped
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :items="newListFiltered"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  class="mb-0"
                  @filtered="onFiltered"
                  @row-clicked="rowClick"
                >
                  <template #cell(primeira_execucao)="data">
                    <b-badge :variant="data.item.primeira_execucao === 'ATIVA' ? 'success' : 'danger'">
                      {{ data.item.primeira_execucao }}
                    </b-badge>
                  </template>
                </b-Table>
              </b-col>
              <b-col
                cols="12"
                class="mt-1"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  size="sm"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import {
  BRow,
  BCol,
  BCard,
  BTable,
  BPagination,
  BFormInput,
  BFormSelect,
  BOverlay,
  BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@/../axios-auth'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BPagination,
    BFormInput,
    BFormSelect,
    BOverlay,
    BBadge,
    vSelect,
  },
  data() {
    return {
      load: true,
      filter: '',
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      fields: [
        { key: 'id', label: 'ID', class: 'text-center' },
        { key: 'data_inicio_campanha', label: 'Data Início Campanha', class: 'text-center' },
        { key: 'data_final_campanha', label: 'Data Final Campanha', class: 'text-center' },
        { key: 'tipo_campanha', label: 'Tipo Campanha', class: 'text-center' },
        { key: 'primeira_execucao', label: 'STATUS', class: 'text-center' },
        { key: 'respiro', label: 'Respiro', class: 'text-center' },
      ],
      campanhas: [],
      statusFilter: [],
    }
  },
  computed: {
    optionsStatus() {
      const { campanhas } = this
      const status = []

      campanhas.map(item => {
        item.primeira_execucao ? status.push(item.primeira_execucao) : null
      })

      const itemsFiltered = [...new Set(status)]

      return itemsFiltered
    },
    newListFiltered() {
      const { campanhas, statusFilter: sF } = this
      let itens = campanhas

      if (sF.length > 0) {
        itens = campanhas.filter(item => (
          (sF.length === 0 || sF.includes(item.primeira_execucao))
        ))
      }
      this.totalRows = itens.length
      return itens
    },
  },
  async created() {
    await this.updateList()
  },
  methods: {
    rowClick(item) {
      this.$router.push({ name: 'campanhas.view', params: { id: item.id } })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updateList() {
      this.campanhas = []
      this.load = true
      axios.get('api/v1/campanha', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          Accept: 'application/json',
        },
      })
        .then(res => {
          // this.totalRows = res.data.dados.length
          res.data.map(dt => {
            this.campanhas.push({
              id: dt.id,
              tipo_campanha: dt.tipo_campanha,
              data_inicio_campanha: dt.data_inicio_campanha ? this.formatDate(new Date(dt.data_inicio_campanha)) : '',
              data_final_campanha: dt.data_final_campanha ? this.formatDate(new Date(dt.data_final_campanha)) : '',
              respiro: dt.respiro,
              faturamento: (dt.faturamento, true),
              qnt_acordos: dt.acordos,
              qnt_clientes: dt.total_clientes,
              primeira_execucao: dt.primeira_execucao ? 'ATIVA' : 'INATIVA',
            })
          })
          this.totalRows = this.campanhas.length
          this.load = false
        })
    },
    formatDate(date) {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
  },
}
</script>
